import jwt_decode from "jwt-decode";
import {DateTime} from "luxon";


export default class AccessToken {
    constructor(data) {

        this._accessToken = data.access_token
        this._expiresIn = data.expires_in
        this._refreshToken = data.refresh_token
        this._type = data.token_type

        this._token = jwt_decode(this._accessToken)
    }

    get raw () {
        return this._accessToken
    }

    get refreshToken() {
        return this._refreshToken
    }

    get expiresIn () {
        return this._token.exp - parseInt(DateTime.now().toSeconds())
    }

    get isExpired() {
        return this._token.exp < DateTime.now().toSeconds()
    }

    get id() {
        return this._token.sub
    }

    get exp() {
        return this._token.exp
    }

    get iat() {
        return this._token.iat
    }

    get user () {
        return this._token.user
    }
}
